import { render, staticRenderFns } from "./ProcurementSalesOrder.vue?vue&type=template&id=244dbda1&"
import script from "./ProcurementSalesOrder.vue?vue&type=script&lang=js&"
export * from "./ProcurementSalesOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports